// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from "vuex";
import VueApollo from "vue-apollo";
import VuePaginate from "vuejs-paginate";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import apolloProvider from "@/services/apollo_provider";
import i18n from "@/locales";

import DefaultLayout from "@/views/layouts/Default";
import ContentLayout from "@/views/layouts/Content";
import ContentWithMapLayout from "@/views/layouts/ContentWithMap";

Vue.component("default-layout", DefaultLayout);
Vue.component("content-layout", ContentLayout);
Vue.component("content-with-map-layout", ContentWithMapLayout);
Vue.component("paginate", VuePaginate);

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueApollo);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  apolloProvider,
  i18n
});



// WEBPACK FOOTER //
// ./src/main.js